// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".groupWarin[data-v-105e4fba]{background:#fae99b}.normal[data-v-105e4fba]{font-weight:400}", ""]);
// Exports
module.exports = exports;
